import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import Checkbox from "@material-ui/core/Checkbox";

export const CalorieSlider = withStyles({
  root: {
    color: "#06cb40",
    height: 8,
  },
  thumb: {
    height: 32,
    width: 32,
    backgroundColor: "#dae3f1",
    border: "5px solid currentColor",
    marginTop: -13,
    marginLeft: -18,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
    "&$disabled": {
      height: 32,
      width: 32,
      backgroundColor: "#dae3f1",
      border: "5px solid #999a9c",
      marginTop: -13,
      marginLeft: -18,
    },
  },
  active: {},
  disabled: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: "#b7c1d6",
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export const MacroSlider = withStyles({
  root: {
    color: "#5c2ff0",
    height: 8,
  },
  thumb: {
    height: 32,
    width: 32,
    backgroundColor: "#dae3f1",
    border: "5px solid currentColor",
    marginTop: -13,
    marginLeft: -18,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
    "&$disabled": {
      height: 32,
      width: 32,
      backgroundColor: "#dae3f1",
      border: "5px solid #999a9c",
      marginTop: -13,
      marginLeft: -18,
    },
  },
  active: {},
  disabled: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: "#b7c1d6",
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export const FatSlider = withStyles({
  root: {
    color: "#e328a2",
    height: 8,
  },
  thumb: {
    height: 32,
    width: 32,
    backgroundColor: "#dae3f1",
    border: "5px solid currentColor",
    marginTop: -13,
    marginLeft: -18,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
    "&$disabled": {
      height: 32,
      width: 32,
      backgroundColor: "#dae3f1",
      border: "5px solid #999a9c",
      marginTop: -13,
      marginLeft: -18,
    },
  },
  active: {},
  disabled: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: "#b7c1d6",
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export const Container = styled.div`
  background: white;
`;

export const ResetContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

export const ResetButton = styled.button`
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const WeekContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  gap: 2px;
`;

export const DayColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.selected ? "#06CB40" : "transparent")};
  background-color: ${(props) => (props.selected ? "#ebffe5" : "transparent")};
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.$isPast ? 0.6 : 1)};
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 8px;
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  transition: opacity 0.2s ease;
`;

export const GreenCheckbox = withStyles({
  root: {
    color: "#06cb40",
    transform: "scale(1.5)",
    padding: "4px",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
    "&.MuiIconButton-root:hover": {
      backgroundColor: "transparent !important",
    },
    "& .MuiTouchRipple-root": {
      color: "#06cb40",
    },
    "& .MuiTouchRipple-rippleVisible": {
      color: "#06cb40",
    },
    "&$checked": {
      color: "#06cb40",
    },
    "&$disabled": {
      color: "#999a9c",
    },
  },
  checked: {},
  disabled: {},
})((props) => <Checkbox {...props} />);

export const DateLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 4px;
`;

export const DayLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

export const CalorieValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`;

export const MacroStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
  padding: 0 8px;
  height: 180px;
  gap: 1px;
`;

export const MacroBar = styled.div`
  width: 48px;
  flex: ${(props) => props.flexValue};
  background-color: ${(props) => props.color};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: white;
  font-weight: 600;
  min-height: 16px;
  opacity: ${(props) => (props.$isPast ? 0.7 : 1)};
  filter: ${(props) => (props.$isPast ? "brightness(0.8)" : "none")};
`;

export const ControlGroup = styled.div`
  margin-bottom: 20px;
  opacity: ${(props) => (props.$reducedOpacity ? 0.4 : 1)};
  transition: opacity 0.2s ease;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ControlLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const Label = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
`;

export const ValueInput = styled.input`
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  width: 80px;
  text-align: center;
  opacity: ${(props) => (props.$reducedOpacity ? 0.4 : 1)};
  transition: opacity 0.2s ease;
  &:focus {
    outline: none;
    border-color: #1976d2;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const SummaryBox = styled.div`
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 24px;
`;

export const SummaryText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ErrorBox = styled.div`
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  margin: 2px 0px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const ErrorIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #c62828;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
`;

